var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('swatches',{attrs:{"colors":"text-advanced","row-length":"10","popover-to":"left"},model:{value:(_vm.col),callback:function ($$v) {_vm.col=$$v},expression:"col"}},[_c('div',{staticClass:"hit-form-control",style:({background: _vm.col}),attrs:{"slot":"trigger","id":_vm.id},slot:"trigger"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }